export {default} from './LinkWallet';
